/* eslint-disable camelcase */
import {
  MarketShareDataTypes,
  MarketShareParamsTypes,
  StockExchangesListTypes,
  DownloadReportListDataTypes,
  ReportCategoriesListTypes,
  ReportListDataParams,
  ReportListDataRes,
  ParamsTypes,
  AnalyticCenterCompaniesTypes,
  DownloadReportListParamsTypes,
  RecommendationCategoryTypes,
  RecommendationTableTypes,
  NewsListTypes,
} from './types';

import axiosInstance from 'services/common/instance';
import { LOCAL_STORAGE } from 'utils/constants';

export const getStockExchangesListService = async (): Promise<StockExchangesListTypes[]> => {
  const res = await axiosInstance.get('stock-exchanges');
  return res.data.data;
};

const locale = window.localStorage.getItem(LOCAL_STORAGE.LANGUAGE) || 'vi';

/**
 * Thị trường chứng khoán
 * @param exchange_code: Mã sàn chứng khoán
 * @param date_string: Khoảng thời gian
 * @param sort_by:  Top cổ phiếu tăng giá mạnh nhất (mặc định)
                    Top cổ phiếu giảm giá mạnh nhất
                    Top cổ phiếu có khối lượng giao dịch nhiều nhất
                    Top cổ phiếu có giá trị giao dịch nhiều nhất
 * @param limit: Số lượng cổ phiếu hiển thị
 * @returns
 */
const getMarketShareService = async (
  params: MarketShareParamsTypes,
): Promise<MarketShareDataTypes> => {
  const res = await axiosInstance.get('stock-quotes/market-share', { params });
  return res.data;
};

export const downloadReportListService = async (params: DownloadReportListParamsTypes):
  Promise<DownloadReportListDataTypes> => {
  const res = await axiosInstance.post('ttpt-reports/create-download', params);
  return res.data.data;
};

export const getReportCategoriesListService = async (): Promise<ReportCategoriesListTypes[]> => {
  const res = await axiosInstance.get('ttpt-report-categories');
  return res.data.data;
};

export const getReportListDataService = async (
  params?: ReportListDataParams,
): Promise<ReportListDataRes> => {
  const res = await axiosInstance.get('ttpt-reports', { params });
  return res.data;
};

export const getAnalyticsCompaniesBySlugService = async (
  slug: string,
): Promise<AnalyticCenterCompaniesTypes> => {
  const response = await axiosInstance.get(`ttpt-companies/${slug}`);
  return response.data.data;
};

export const getRecommendationCategoryService = async (
  params?: ReportListDataParams,
): Promise<RecommendationCategoryTypes[]> => {
  const res = await axiosInstance.get('ttpt-suggestion-categories', { params });
  return res.data.data;
};

export const getRecommendationByCateCodeService = async (
  params?: ReportListDataParams,
): Promise<RecommendationTableTypes> => {
  const res = await axiosInstance.get('ttpt-recommendations', { params });
  return res.data.data;
};

export const downloadRecommendationService = async (params?: ReportListDataParams):
  Promise<Blob> => {
  const res = await axiosInstance.post(
    `ttpt-recommendations/export?locale=${locale}`,
    params,
    {
      responseType: 'blob',
    },
  );
  return res.data;
};

export const getRecommendationByCateCodeHistoryService = async (
  params?: ReportListDataParams,
): Promise<RecommendationTableTypes[]> => {
  const res = await axiosInstance.get('ttpt-recommendations/history', { params });
  return res.data.data;
};

export const downloadRecommendationHistoryService = async (params?: ReportListDataParams):
  Promise<Blob> => {
  const res = await axiosInstance.post(`ttpt-recommendations/history/export?locale=${locale}`,
    params,
    {
      responseType: 'blob',
    });
  return res.data;
};

export const getNewsListDashboardService = async (
  params: ParamsTypes,
): Promise<NewsListTypes[]> => {
  const response = await axiosInstance.get('sgdck-news', { params });
  return response.data.data;
};

export default getMarketShareService;
